import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useUploadImage = () => {
  const token = useAuthToken();

  const uploadImage = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/web-image-upload", credentials, token);
  };

  return uploadImage;
};

export const useGetImages = () => {
  const token = useAuthToken();

  const getImges = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    return apiRequest("get", "/api/web-image-upload", null, token);
  };

  return getImges;
};

export const useUpdateImages = (id) => {
  const token = useAuthToken();

  const updateImages = async (formData) => {
    if (!token) {
      throw new Error("Token is missing");
    }
    const response = await apiRequest(
      "patch",
      `/api/web-image-upload/${id}`,
      formData,
      token
    );

    return response;
  };

  return updateImages;
};
